import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { FpCorrelationTabs } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/enums/fp-correlation-tabs.enum';
import { IFpCorrelationData } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-data';

export interface IFpCorrelationCommentsState {
  currentTab: FpCorrelationTabs.Comments;
  date: string | null;
  data: IFpCorrelationData | null;
  loading: boolean;
  saved: boolean;
  error: IApiBaseErrorResponse | null;
}

export const initialFpCorrelationCommentsState: IFpCorrelationCommentsState = {
  currentTab: FpCorrelationTabs.Comments,
  date: null,
  data: null,
  loading: false,
  saved: false,
  error: null,
};
